import React, {
  FormEvent,
  FunctionComponent,
  useCallback,
  useState,
} from 'react';

import { CardList, SubmitButton } from 'components';
import { FormGroup } from 'components/chroma';

import { MotorFullPageProps, SpecialDetail } from 'scenes/motor/types';
import { getSpecialDetails } from 'scenes/motor/selectors';

import { SpecialDetailCard } from './SpecialDetailCard';

const options = Object.values(SpecialDetail);

const isSelected = (
  specialDetail: SpecialDetail,
  selectedSpecialDetails: SpecialDetail[]
): boolean => selectedSpecialDetails.some((option) => option === specialDetail);

const anySelected = (items: SpecialDetail[]): boolean => items.length > 0;

export const SpecialDetailsStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
}) => {
  const [selectedSpecialDetails, setSelectedSpecialDetails] = useState(
    getSpecialDetails(funnelState)
  );

  const onSubmit = useCallback(
    (event: FormEvent) => {
      onNext({ specialDetails: selectedSpecialDetails });
      event.preventDefault();
    },
    [onNext, selectedSpecialDetails]
  );

  const handleSelect = useCallback(
    (specialDetail: SpecialDetail) => {
      if (specialDetail === SpecialDetail.None) {
        setSelectedSpecialDetails(
          selectedSpecialDetails.includes(SpecialDetail.None)
            ? []
            : [SpecialDetail.None]
        );
        return;
      }

      const copySpecialDetails = selectedSpecialDetails.filter(
        (item) => item !== SpecialDetail.None
      );

      const foundIndex = selectedSpecialDetails.findIndex(
        (item) => item === specialDetail
      );
      if (foundIndex > -1) {
        copySpecialDetails.splice(foundIndex, 1);
      } else {
        copySpecialDetails.push(specialDetail);
      }

      setSelectedSpecialDetails(copySpecialDetails);
    },
    [selectedSpecialDetails]
  );

  return (
    <form onSubmit={onSubmit}>
      <FormGroup
        legend="In the last 5 years, has any policy holder or driver of the car had:"
        helpText="Select all that apply."
      >
        <CardList marginBottom="1rem">
          {options.map((specialDetail, index) => (
            <SpecialDetailCard
              specialDetail={specialDetail}
              key={specialDetail}
              selected={isSelected(specialDetail, selectedSpecialDetails)}
              onClick={() => handleSelect(specialDetail)}
              screenReaderText={`Option ${index + 1} of ${options.length}`}
            />
          ))}
        </CardList>
      </FormGroup>
      <SubmitButton enabled={anySelected(selectedSpecialDetails)}>
        Next
      </SubmitButton>
    </form>
  );
};

export default SpecialDetailsStep;
